/**
 * Single-owner token for the shared DicomProcessor ingest: every
 * parse-and-commit claims it and releases on settle, so two ingests can
 * never interleave, whichever started first. Module state, not Recoil: the
 * claim must be atomic within a tick.
 */
let claimed = false;

/** Claims the ingest; `false` means another ingest holds the processor. */
export function claimIngest(): boolean {
    if (claimed) {
        return false;
    }
    claimed = true;
    return true;
}

export function releaseIngest(): void {
    claimed = false;
}

/** For pre-checks whose input a deeper refusal would consume. */
export function isIngestClaimed(): boolean {
    return claimed;
}
